import { epicRequest } from 'app'

export const USER_FETCH = 'USER_FETCH'
export const USER_FETCH_ERROR = 'USER_FETCH_ERROR'
export const USER_FETCH_FULFILLED = 'USER_FETCH_FULFILLED'
export const USER_FETCH_CANCELED = 'USER_FETCH_CANCELED'

export const USER_BANNER_ADD = 'USER_BANNER_ADD'
export const USER_BANNER_ADD_ERROR = 'USER_BANNER_ADD_ERROR'
export const USER_BANNER_ADD_FULFILLED = 'USER_BANNER_ADD_FULFILLED'
export const USER_BANNER_ADD_CANCELED = 'USER_BANNER_ADD_CANCELED'

export const USER_LIKE = 'USER_LIKE'
export const USER_LIKE_ERROR = 'USER_LIKE_ERROR'
export const USER_LIKE_FULFILLED = 'USER_LIKE_FULFILLED'
export const USER_LIKE_CANCELED = 'USER_LIKE_CANCELED'

export const USER_INITIAL_STATE = {
  data: [],
  error: null,
  pagination: null,
}

export const userFetch = (userId) => ({
  payload: {
    userId,
  },
  type: USER_FETCH,
})

export const userFetchFulfilled = (payload) => ({
  payload,
  type: USER_FETCH_FULFILLED,
})

export const userFetchError = (payload) => ({
  payload,
  type: USER_FETCH_ERROR,
})

export const userFetchCanceled = () => ({
  payload: null,
  type: USER_FETCH_CANCELED,
})

export const userFetchEpic = epicRequest({
  actionType: USER_FETCH,
  errorAction: userFetchError,
  fulfilledAction: userFetchFulfilled,
  request: ({ payload }) => `user/${payload.userId}`,
  untilTypes: USER_FETCH_CANCELED,
})

export const userLike = (userId, like) => ({
  payload: {
    like,
    userId,
  },
  type: USER_LIKE,
})

export const userLikeFulfilled = (payload) => ({
  payload,
  type: USER_LIKE_FULFILLED,
})

export const userLikeError = (payload) => ({
  payload,
  type: USER_LIKE_ERROR,
})

export const userLikeCanceled = () => ({
  payload: null,
  type: USER_LIKE_CANCELED,
})

export const userLikeEpic = epicRequest({
  actionType: USER_LIKE,
  errorAction: userLikeError,
  fulfilledAction: userLikeFulfilled,
  request: ({ payload }) => ({
    method: payload.like ? 'post' : 'delete',
    url: `user/${payload.userId}/${payload.like ? 'like' : 'unfollow'}`,
  }),
  untilTypes: USER_LIKE_CANCELED,
})

export const userBannerAdd = (image) => ({
  payload: {
    image,
  },
  type: USER_BANNER_ADD,
})

export const userBannerAddFulfilled = (payload) => ({
  payload,
  type: USER_BANNER_ADD_FULFILLED,
})

export const userBannerAddCanceled = () => ({
  payload: null,
  type: USER_BANNER_ADD_CANCELED,
})

export const userBannerAddEpic = epicRequest({
  actionType: USER_BANNER_ADD,
  errorAction: userLikeError,
  fulfilledAction: (response, action) => {
    response.data[0].preview = action.payload.image
    return userBannerAddFulfilled(response)
  },
  request: ({ payload }) => {
    const formData = new FormData()
    formData.append('picture', payload.image)

    return {
      body: formData,
      method: 'post',
      url: 'user/picture',
    }
  },
  untilTypes: USER_BANNER_ADD_CANCELED,
})
